// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules_temp/buddy/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules_temp/buddy/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#ss7rXuQP8mDEvUNR19J3 {\n    color: blue;\n    margin-left: 0.7em;\n    margin-top: 0.8em;\n    padding-top: 0.3em;\n}\n", "",{"version":3,"sources":["webpack://./src/fe/index/order-editor.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":["#addItem {\n    color: blue;\n    margin-left: 0.7em;\n    margin-top: 0.8em;\n    padding-top: 0.3em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addItem": "ss7rXuQP8mDEvUNR19J3"
};
export default ___CSS_LOADER_EXPORT___;
